import { BookRequest } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.BOOK_REQUEST.path,
      name: "Book Request",
      key: adminRouteMap.BOOK_REQUEST.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.BOOK_REQUEST.icon,
      element: <BookRequest />,
    },
  ];
}
